import { render } from "./DecolopTeamsOverview.vue?vue&type=template&id=552efc32"
import script from "./DecolopTeamsOverview.vue?vue&type=script&lang=js"
export * from "./DecolopTeamsOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__